import TabPreferencesModalController from './modalCtrl/TabPreferencesModalController';
import DeleteTabModalController from './modalCtrl/DeleteTabModalController';
import registerAsfTabsetDirective from './IBTabsetDirective';
import { registerAsfTabDirective, registerAsfTabHeadingTranscludeDirective } from './TabDirective';


export default function registerTab(angular) {
    const module = angular.module('assessmentFrontendDirectives');
    
    module.controller('TabPreferencesModalController', TabPreferencesModalController);
    module.controller('DeleteTabModalController', DeleteTabModalController);
    
    registerAsfTabsetDirective(module);
    registerAsfTabDirective(module);
    registerAsfTabHeadingTranscludeDirective(module);
}